/** Tailwind classes matching the integration lock chip (formerly Badge.module.css). */
export const INTEGRATION_LOCK_CHIP_CLASS =
  "tw-flex tw-items-center tw-w-fit tw-cursor-pointer tw-px-[10px] tw-py-[5px] tw-rounded-[5px] tw-text-xs tw-font-medium tw-text-[rgba(51,34,0,1)] tw-bg-[linear-gradient(rgba(255,203,100,1),rgba(255,171,3,1))]";

export const INTEGRATION_LOCK_ICON_CLASS =
  "!tw-h-3 !tw-w-3 tw-fill-[rgba(51,34,0,1)]";
